import _ from 'lodash';
import { modifyToInstance } from '../../lib/Formatter';

export const columns = [
    {    
        dataField: 'sortOrder',
        text: 'Permission',
        sort: true,
        headerStyle: { borderColor: '#a81933', width: '70%' },
        formatter: (_cell, row) => {
            const permissionName = ((!_.isEmpty(row.parent) && !_.isEmpty(row.parent.parent) && (row.parent.parent.parent))
                ? row.parent.parent.parent.name + ' > ' + row.parent.parent.name + ' > ' + row.parent.name + ' > ' + row.name
                : ((!_.isEmpty(row.parent) && (row.parent.parent))
                    ? row.parent.parent.name + ' > ' + row.parent.name + ' > ' + row.name
                    : ((!_.isEmpty(row.parent)) ? row.parent.name + ' > ' + row.name : row.name)
                )
            );
            return (modifyToInstance(permissionName));
        }
    },
    {
        dataField: 'canEdit',
        text: 'Can Edit',
        sort: true,
        allowCheckAll: false,
        headerStyle: { borderColor: '#a81933', width: '15%' },
        isCheckbox: true,
    },
    {
        dataField: 'enabled',
        text: 'Enabled',
        sort: true,
        allowCheckAll: false,
        headerStyle: { borderColor: '#a81933', width: '15%' },
        isCheckbox: true,
    }
];

export const sorting = [{
    dataField: 'sortOrder',
    order: 'asc'
}];